import styled from 'styled-components';
import ds, { media } from 'designsystem';

const LogoImage = styled.img`
  position: relative;
  width: ${ds.get('metrics.xxl')};
  margin-left: ${ds.get('metrics.s')};
  margin-top: auto;
  margin-bottom: auto;
  ${media.tablet`
    ${({ big }) => (big ? `width: calc(${ds.get('metrics.l')} * 3);` : '')}
  `}
`;

export default LogoImage;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/Logo/LogoImage.jsx